import { useTranslation } from "react-i18next";

import { DashboardTile } from "../../shared/DashboardTile/DashboardTile";
import { ArrowBadge } from "../../shared/ArrowBadge/ArrowBadge";
import startUnscheduledImg from "~/content/images/start_unscheduled.jpg";
import startUnscheduledVideo from "~/content/videos/unscheduled_event_bg.mp4";
import AssignmentIcon from "~/content/icons/assignment.svg?react";

import "./StartUnscheduledTile.css";

export function StartUnscheduledQuestionnaireTile() {
  const { t } = useTranslation();

  return (
    <DashboardTile
      className="start-unscheduled"
      page="/unscheduled-events"
      testId="start-unscheduled-tile"
      controls={() => <ArrowBadge color="white" />}
    >
      <video
        aria-hidden="true"
        autoPlay
        className="start-unscheduled__background"
        loop
        muted
        playsInline
        poster={startUnscheduledImg}
        tabIndex="-1"
      >
        <source src={startUnscheduledVideo} type="video/mp4" />
        <img src={startUnscheduledImg} alt="" />
      </video>
      <div className="start-unscheduled__overlay" aria-hidden="true" />
      <div className="dashboard-tile-column">
        <h2 className="dashboard-tile-column__title">
          {t("home.unscheduled_event.title")}
        </h2>
        <div className="dashboard-tile-column__bottom">
          <AssignmentIcon
            className="dashboard-tile-column__icon"
            aria-hidden="true"
          />
          <span className="dashboard-tile-column__description">
            {t("home.unscheduled_event.description")}
          </span>
        </div>
      </div>
    </DashboardTile>
  );
}
